module.exports = __webpack_public_path__ + "static/media/92.bb6bbed8.jpg";